import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';
import {MedicalRecordSportModel} from '../../../api/model/medicalRecordSport.model';

@Injectable({providedIn: 'root'})
export class MedicalSportRepository extends AbstractRepositoryV2<MedicalRecordSportModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('MedicalSport', serviceElementsFactory, injector);
    }
}
